import { observer } from 'mobx-react-lite'
import { TextInputContainer } from '@/components/inputs/TextInputContainer'
import { masks } from '@/utils/input-mask-util'
import { type EditBusinessProfileDialogViewModel } from './EditBusinessProfileDialogViewModel'
import { PhysicalAddressEditorContainer } from '@/features/jobs/info-gathering/components/PhysicalAddressEditorContainer'
import { EditBusinessProfileDialog } from '@/features/jobs/info-gathering/business-info/components/EditBusinessProfileDialog'

export interface EditBusinessProfileDialogContainerProps {
  vm: EditBusinessProfileDialogViewModel
}

export const EditBusinessProfileDialogContainer = observer(
  function EditBusinessProfileDialogContainer({
    vm,
  }: EditBusinessProfileDialogContainerProps) {
    const editor = vm.businessProfileEditorVm
    const businessInfoVm = editor.businessInfoVm
    const contactInfoVm = editor.contactInfoVm
    const physicalAddressVm = contactInfoVm.physicalAddressVm

    return (
      <EditBusinessProfileDialog
        showing={vm.modal.showing}
        onRequestClose={vm.submit.pending ? undefined : vm.modal.close}
        onSubmit={vm.submit}
        isSubmitPending={vm.submit.pending}
        businessFields={
          <>
            <TextInputContainer
              model={businessInfoVm}
              field="businessName"
              name="businessName"
              label="Business name"
              error={businessInfoVm.validation.getError('businessName')}
              data-test="edit-business-name"
            />
            <TextInputContainer
              model={businessInfoVm}
              field="dateOfIncorporation"
              name="dateOfIncorporation"
              label="Date of incorporation"
              placeholder="MM/DD/YYYY"
              mask={masks.americanDate}
              error={businessInfoVm.validation.getError('dateOfIncorporation')}
              data-test="edit-business-date-of-incorporation"
            />
            <TextInputContainer
              model={businessInfoVm}
              field="employerIdentificationNumber"
              name="employerIdentificationNumber"
              label="Employer identification number (EIN)"
              placeholder="xx-xxxxxxx"
              mask={masks.ein}
              error={businessInfoVm.validation.getError(
                'employerIdentificationNumber',
              )}
              data-test="edit-business-ein"
            />
          </>
        }
        contactFields={
          <>
            <TextInputContainer
              model={contactInfoVm}
              field="email"
              name="email"
              label="Email address"
              placeholder="name@example.com"
              controlType="email"
              error={contactInfoVm.validation.getError('email')}
              data-test="edit-business-email"
            />
            <TextInputContainer
              model={contactInfoVm}
              field="phoneNumber"
              name="phoneNumber"
              label="Phone number"
              placeholder="(555) 123-4567"
              controlType="tel"
              error={contactInfoVm.validation.getError('phoneNumber')}
              data-test="edit-business-phone"
            />
            <PhysicalAddressEditorContainer
              vm={physicalAddressVm}
              testId="edit-business"
            />
          </>
        }
      />
    )
  },
)
